import { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Loading } from "../Other/Loading";

const Partners = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  

  useEffect(() => {
  const fetchData = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/partners`);
        console.log("||||||||||||||||||API Response:", response.data); // Log response to debug
        const events = JSON.parse(response.data);
        console.log("API Response:", events);
        setData(events);  // turns string into array of objects
      }
      catch (error) {
        console.error("Error fetching reasons data:", error);
      }
  };

  fetchData();
}, [t]);

  if (error) return <div className="text-center text-red-500 p-4">{error}</div>;

  if (!data) return <div><Loading/></div>;

  return (
    <section className="max-w-full md:max-w-3xl lg:max-w-4xl xl:max-w-6xl mx-auto px-4 md:px-8 mt-3 py-16 bg-white shadow-lg border">
      <h2 className="text-center text-1xl md:text-2xl lg:text-2xl font-bold text-gray-900 mb-12 w-full max-w-3/4">
        {t(
          "State-of-the-art curriculum co-created and certified by world-class universities and organizations"
        )}
      </h2>

      <div className="space-y-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 items-center justify-items-center">
          {data.partners.map((partner) => (
            <div key={partner.id} className="w-full max-w-[200px] p-4">
              <img
                src={`${process.env.REACT_APP_COURSE_API_BASEURL}${partner.logo}` || "/placeholder.svg"}
                alt={partner.name}
                className="w-full h-auto object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
